<script>
import appConfig from '@/app.config'
import PageHeader from '@/components/page-header'
import Vsms from './Domain/Vsms'
import Layout from '@/router/layouts/main'
import { todoComputed, todoMethods } from '@/state/helpers'
import { Helper } from '@/mixin/helper'
import { mapGetters } from 'vuex'

export default {
  page: {
    title: 'Manage Domain',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    Vsms,
  },
  handleSubmit() {
    this.$nextTick(() => {
      this.$bvModal.hide('modal-set')
    })
  },
  data() {
    return {
      region: 'SG',
    }
  },
  computed: {
    ...todoComputed,
    ...mapGetters({
      hasAccess: 'identity/hasAccess',
    }),
    title() {
      return this.$t('domain.title')
    },
  },
  mixins: [Helper],
  methods: {
    ...todoMethods,
  },
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" />
    <div class="card mc-card mc-card-front">
      <div class="me-3 mb-3 d-flex align-items-center justify-content-between">
        <b-form-select
          class="form-select form-select-md __limit--dropdown w-auto"
          v-model="region"
        >
          <b-form-select-option value="SG">Semua Region</b-form-select-option>
          <b-form-select-option value="ID">Indonesia</b-form-select-option>
        </b-form-select>
        <div
          v-if="hasAccess(['sms-hosted-zone:read'])"
          class="float-end">
          <b-button
            @click="$router.push({ name: 'Manage Domain Setting' })"
            variant="outline-primary"
            menu-class="dropdown-menu-end"
            class="ms-3"
          >
            <i class="mc-fa icon-outline_settings"></i> Pengaturan
          </b-button>
        </div>
      </div>
      <div class="card-body">
        <b-tabs content-class="p-3 text-muted">
          <b-tab active class="border-0">
            <template v-slot:title>
              <span class="d-inline-block d-sm-none">
                <i class="fas fa-home"></i>
              </span>
              <span class="d-none d-sm-inline-block">VSMS</span>
            </template>
            <vsms :region="region"/>
          </b-tab>
        </b-tabs>
      </div>
    </div>
  </Layout>
</template>
